// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolsie.page.section{margin:auto}.toolsie.page.section:after{content:\"\";display:table;clear:both}.toolsie.page.section .inner{margin:auto}.toolsie.page.section .inner:after{content:\"\";display:table;clear:both}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
